export class ScriptUtils {
    static load<T>(url: string, objectName?: string): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            ScriptUtils.loadScript(url,
                (response: any) => {
                    if (objectName) {
                        var result = window[objectName] as T;
                        if (result) {
                            resolve(result);
                        } else {
                            reject(result);
                        }
                    } else {
                        resolve(response);
                    }
                },
                (error: any) => {
                    reject(error);
                });
        });
    }

    private static loadScript(scriptSrc: string, successCallback: (this: HTMLElement, ev: Event) => any, errorCallback: (this: HTMLElement, ev: Event) => any) {
        var oHead = document.getElementsByTagName('head')[0];
        var oScript = document.createElement('script');
        oScript.type = 'text/javascript';
        oScript.src = scriptSrc;
        oScript.onload = successCallback;
        oScript.onerror = errorCallback;
        oHead.appendChild(oScript);
    }
}



// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/Helpers/ScriptUtils.ts